export type PanAnim = { current: { raf: number; cancelled: boolean } | null };

// Eased pan that animates smoothly regardless of distance/zoom. Google's panTo
// only animates when the target is already within the viewport, so it snaps for
// far / zoomed-in moves. Linear lat/lng interpolation is fine over the short
// distances within a city. Any in-flight pan is cancelled before a new one.
export const animateMapPan = (map: google.maps.Map, anim: PanAnim, target: { lat: number; lng: number }, ms = 500) => {
  const startCenter = map.getCenter();
  if (!startCenter) {
    map.setCenter(target);
    return;
  }
  if (anim.current) anim.current.cancelled = true;
  const from = { lat: startCenter.lat(), lng: startCenter.lng() };
  const state = { raf: 0, cancelled: false };
  anim.current = state;
  const t0 = performance.now();
  const ease = (t: number) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
  const step = (now: number) => {
    if (state.cancelled) return;
    const p = Math.min(1, (now - t0) / ms);
    const e = ease(p);
    map.setCenter({ lat: from.lat + (target.lat - from.lat) * e, lng: from.lng + (target.lng - from.lng) * e });
    if (p < 1) state.raf = requestAnimationFrame(step);
  };
  state.raf = requestAnimationFrame(step);
};
